import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import useStyles from './useStyles';
import { pickChannelIcon } from './utils';

export const ChannelIcon = ({ className, channel, ...restProps }) => {
  const styles = useStyles();

  const IconClass = useMemo(() => pickChannelIcon(channel), [channel]);
  if (!IconClass) {
    return null;
  }

  return (
    <IconClass
      className={cx(styles.root, className)}
      {...restProps}
    />
  );
};

ChannelIcon.propTypes = {
  className: PropTypes.string,
  channel: PropTypes.string.isRequired,
};

ChannelIcon.defaultProps = {
  className: null,
};
